'use client'

import { usePathname } from 'next/navigation'
import { useEffect } from 'react'

export default function NoNavExplanationLayout({
  children,
}: {
  children: React.ReactNode
}) {
  const pathname = usePathname()

  useEffect(() => {
    const isExplanationPage = pathname?.startsWith('/explanation')

    if (isExplanationPage) {
      document.body.classList.add('explanation-page')
    } else {
      document.body.classList.remove('explanation-page')
    }

    // Cleanup on unmount
    return () => {
      document.body.classList.remove('explanation-page')
    }
  }, [pathname])

  // Add margin only when header is shown (not on checkout pages)
  const shouldShowHeader = !pathname?.startsWith('/explanation')
  const marginClass = shouldShowHeader ? 'mt-[84px] lg:mt-[130px]' : ''

  return <div className={`${marginClass} flex-grow`}>{children}</div>
}
